import { useMemo } from 'react';
import { isFeatureEnabled, getFeatureFlag, getAllFeatureFlags, getUIEnvironment } from '@/config/featureFlags';

export const useFeatureFlag = (featureName: string) => {
  const isEnabled = useMemo(() => isFeatureEnabled(featureName), [featureName]);
  
  return isEnabled;
};

export const useFeatureFlags = () => {
  const allFlags = useMemo(() => getAllFeatureFlags(), []);
  
  return allFlags;
};

export const useUIEnvironment = () => {
  const environment = useMemo(() => getUIEnvironment(), []);
  
  return environment;
};

export default useFeatureFlag;